exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-debugpoint[data-v-04b4ced9]{height:1rem;width:1rem;border:1px solid var(--fts-block-danger);border-radius:50%;background:#fff;cursor:pointer;transition:all .3s ease-in-out}.fts-automation-debugpoint.automation-debugpoint--active[data-v-04b4ced9]{background:var(--fts-block-danger)}", ""]);

// exports
